import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { _ as _objectSpread2 } from './_rollupPluginBabelHelpers-05128ded.js';
import { useState, useRef, useCallback } from 'react';
import { u as useMediaQueryContext } from './MediaQueryContext-d6110905.js';
var DEFAULT_DURATION = 300;
function preventDefault(e) {
  if (!isTouchEvent(e)) {
    return;
  }
  if (e.touches.length < 2 && e.preventDefault) {
    e.preventDefault();
  }
}
function isTouchEvent(e) {
  return e && 'touches' in e;
}
function useLongPress(_ref) {
  var onLongPress = _ref.onLongPress,
    onClick = _ref.onClick;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$delay = _ref2.delay,
    delay = _ref2$delay === void 0 ? DEFAULT_DURATION : _ref2$delay,
    _ref2$shouldPreventDe = _ref2.shouldPreventDefault,
    shouldPreventDefault = _ref2$shouldPreventDe === void 0 ? true : _ref2$shouldPreventDe,
    _ref2$shouldStopPropa = _ref2.shouldStopPropagation,
    shouldStopPropagation = _ref2$shouldStopPropa === void 0 ? false : _ref2$shouldStopPropa;
  var _useMediaQueryContext = useMediaQueryContext(),
    isMobile = _useMediaQueryContext.isMobile;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    longPressTriggered = _useState2[0],
    setLongPressTriggered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragTriggered = _useState4[0],
    setDragTriggered = _useState4[1]; // https://www.typescriptlang.org/docs/handbook/utility-types.html#returntypetype
  var timeout = useRef();
  var target = useRef();
  var start = useCallback(function (e) {
    e.persist();
    var clonedEvent = _objectSpread2({}, e);
    setDragTriggered(false);
    if (shouldStopPropagation) {
      e.stopPropagation();
    }
    if (shouldPreventDefault && e.target) {
      e.target.addEventListener('touchend', preventDefault, {
        passive: false
      });
      target.current = e.target;
    }
    timeout.current = setTimeout(function () {
      onLongPress(clonedEvent);
      setLongPressTriggered(true);
    }, delay);
  }, [onLongPress, delay, shouldPreventDefault, shouldStopPropagation, isMobile]);
  var clear = useCallback(function (e) {
    var shouldTriggerClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var onDrag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (onDrag) {
      setDragTriggered(true);
    } else {
      setDragTriggered(false);
    }
    if (timeout !== null && timeout !== void 0 && timeout.current) {
      clearTimeout(timeout.current);
    }
    if (shouldTriggerClick && !longPressTriggered && !dragTriggered) {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
    setLongPressTriggered(false);
    if (shouldPreventDefault && target.current) {
      target.current.removeEventListener('touchend', preventDefault);
    }
  }, [shouldPreventDefault, onClick, longPressTriggered, dragTriggered]);
  return {
    onMouseDown: function onMouseDown(e) {
      return start(e);
    },
    onMouseUp: function onMouseUp(e) {
      return clear(e);
    },
    onMouseLeave: function onMouseLeave(e) {
      return clear(e, false);
    },
    onTouchStart: function onTouchStart(e) {
      return start(e);
    },
    // setDragTriggered as true on touchmove, so that next onTouchEnd is ignored
    // if we dont do it, onClick?.(e) will be triggred, see inside clear()
    onTouchMove: function onTouchMove(e) {
      return clear(e, false, true);
    },
    onTouchEnd: function onTouchEnd(e) {
      return clear(e);
    }
  };
}
export { useLongPress as u };